module.exports = __webpack_public_path__ + "img/sample02.9464f7a6.gif";